import lfRequest from '@/service/index'

export function getLibraryGenerateUrl(materialLibraryId: string) {
  return lfRequest.get<any[]>({
    url: `/main/promotionLibraryGenerate/generate/${materialLibraryId}`
  })
}
